import React from 'react';
import '../styles/Orders.css';

export default function Orders() {
  return (
    <div className="page">
      <h1>Orders</h1>
      <p>Yahan Orders ka content aayega.</p>
    </div>
  );
}
